import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

import { audiences } from '@marketing/data/audiences';
import { AudienceIcon } from '@marketing/illustrations/AudienceIcon';
import { fadeUp, revealOnView, stagger } from '@marketing/motion/variants';

// ============================================================
// AudienceCards — 4 públicos do Lume com tilt sutil em hover
// ============================================================

export function AudienceCards() {
  return (
    <section
      id="para-quem-e"
      className="lume-section lume-section--alt"
      aria-labelledby="audiences-title"
    >
      <div className="lume-container">
        <motion.header
          {...revealOnView}
          variants={stagger(0.08)}
          className="lume-stack lume-stack-md"
          style={{ marginBottom: 'clamp(2rem, 4vw, 3rem)', maxWidth: '48rem' }}
        >
          <motion.p variants={fadeUp} className="lume-eyebrow">Para quem é</motion.p>
          <motion.h2 variants={fadeUp} id="audiences-title" className="lume-h2 lume-text-balance">
            Adapta-se a cada papel — sem perder a coerência clínica
          </motion.h2>
          <motion.p variants={fadeUp} className="lume-body-lg lume-text-pretty">
            Quatro experiências distintas compartilhando o mesmo prontuário. Cada papel vê apenas o
            que faz sentido para sua tarefa, com hierarquia visual e linguagem apropriadas.
          </motion.p>
        </motion.header>

        <motion.div
          {...revealOnView}
          variants={stagger(0.1)}
          style={{
            display: 'grid',
            gap: '1.25rem',
            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          }}
        >
          {audiences.map((a) => (
            <motion.article
              key={a.id}
              variants={fadeUp}
              className="lume-card"
              whileHover={{ y: -4, scale: 1.01 }}
              transition={{ duration: 0.25, ease: [0.2, 0.8, 0.2, 1] }}
            >
              <AudienceIcon iconKey={a.iconKey} />
              <h3 className="lume-h3" style={{ marginTop: '1rem' }}>{a.title}</h3>
              <p
                style={{
                  color: 'var(--color-fg-subtle)',
                  fontSize: '0.875rem',
                  marginTop: '0.25rem',
                  marginBottom: '1rem',
                }}
              >
                {a.subtitle}
              </p>
              <ul
                role="list"
                style={{
                  listStyle: 'none',
                  margin: 0,
                  padding: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.5rem',
                }}
              >
                {a.highlights.map((h) => (
                  <li
                    key={h}
                    style={{
                      display: 'flex',
                      gap: '0.5rem',
                      fontSize: '0.9rem',
                      color: 'var(--color-fg-muted)',
                    }}
                  >
                    <Check
                      size={16}
                      strokeWidth={2.5}
                      aria-hidden="true"
                      style={{ color: 'var(--color-warm-700)', flexShrink: 0, marginTop: 3 }}
                    />
                    <span>{h}</span>
                  </li>
                ))}
              </ul>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
